<!--
 * @Author: zb
 * @LastEditors: Do not edit
 * @Date: 2019-08-08 19:41:58
 * @LastEditTime: 2019-08-09 17:01:28
 * @Version: 1.0
 * @Description:  石化运输页面
 * @Company: 济南广域软件
 * @Copyright: Copyright (c) Jnwat Soft
 * @Remarks: 备注
 -->

<template>
  <div class="Transport-wrap">
    <section class="transport-logo">
      <img src="@/assets/img/transport.png" width="100%">
    </section>
    <div class="tab-menu-content">
      <div class="tab-menu">
        <router-link :to="{name:'SourceNews'}" tag="div" class="nav-link">
          <span>货源信息</span>
        </router-link>
        <div class="vertical" />
        <router-link :to="{name:'TransportNews'}" tag="div" class="nav-link">
          <span>运力信息</span>
        </router-link>
      </div>
    </div>
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { isValidArray } from '@/utils/utilsMethods'
export default {
  name: 'PetroTransport',
  computed: {
    ...mapGetters(['roles'])
  },
  watch: {
    $route: {
      handler(route) {
        if (route.params.home != true) {
          if (route.name === 'PetroTransport') {
            // 如果是货源方,则跳转至运力列表,否则打开货源列表
            if (isValidArray(this.roles)) {
              if (
                this.roles.some(role => {
                  return role.indexOf('1') === 0
                })
              ) {
                this.$router.push({ name: 'TransportNews' })
              } else {
                this.$router.push({ name: 'SourceNews' })
              }
            } else {
              this.$router.push({ name: 'SourceNews' })
            }
          }
        }
      },
      deep: true
    }
  },
  created() {
    if (this.$route.params.home != true) {
      // 如果是货源方,则跳转至运力列表,否则打开货源列表
      if (isValidArray(this.roles)) {
        if (
          this.roles.some(role => {
            return role.indexOf('1') === 0
          })
        ) {
          this.$router.push({ name: 'TransportNews' })
        } else {
          this.$router.push({ name: 'SourceNews' })
        }
      } else {
        this.$router.push({ name: 'SourceNews' })
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.tab-menu-content {
  box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.14);
  .tab-menu {
    width: 1200px;
    margin: 0 auto;
    display: flex;
  }
  .vertical {
    border-left: 1px solid #989898;
    margin-top: 8px;
    margin-bottom: 8px;
    opacity: 0.5;
  }
  .nav-link {
    span {
      font-size: 16px;
    }
    width: 50%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    cursor: pointer;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    &.active {
      span {
        color: #be2316;
        font-weight: bold;
      }
    }
  }
}
.Transport-wrap {
  width: 100%;
}
.transport-logo {
  width: 100%;
  max-height: 388px;
  overflow: hidden;
  img {
    width: 100%;
    min-width: 1200px;
  }
}

/deep/.el-cascader {
  min-width: 476px;
}
</style>
